import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import VideoLoggedOutApp from 'bundles/video-logged-out-page/components/VideoLoggedOutApp';

import 'css!bundles/video-logged-out-page/styl/index';

const OndemandLoggedOutCdpRedirector = () => import('bundles/ondemand/components/OndemandLoggedOutCdpRedirector');
const VLPContainer = () => import('bundles/video-logged-out-page/components/VLPContainer');
const OldUrlRedirector = () => import('bundles/video-logged-out-page/components/OldUrlRedirector');

export default (
  <Route path="/" component={VideoLoggedOutApp}>
    {/* This is old URL path. We have changed the URL path for VLP to be lecture/courseSlug/itemSlug-itemId */}
    <Route path="learn/:courseSlug/lecture/:id/:slug" getComponent={loadOnRoute(OldUrlRedirector)} />;
    {/*
    These routes are relevant to logged out users. Backwards compatibile behavior specifies to route
    these back to the CDP.
    TODO (ANY FLEX ENGINEER): Re-evaluate whether or not we should just pop up the AuthenticationModal
    like we do on item pages.
  */}
    <Route path="lecture/:courseSlug/:itemSlugAndId" getComponent={loadOnRoute(VLPContainer)} />
    <Route path="learn/:courseSlug/home/welcome" getComponent={loadOnRoute(OndemandLoggedOutCdpRedirector)} />
    <Route path="learn/:courseSlug/home/info" getComponent={loadOnRoute(OndemandLoggedOutCdpRedirector)} />
    {/* End for backwards compatibility */}
  </Route>
);
